import { render } from "./BindBankCard.vue?vue&type=template&id=1dfc39c4&scoped=true"
import script from "./BindBankCard.vue?vue&type=script&lang=js"
export * from "./BindBankCard.vue?vue&type=script&lang=js"

import "./BindBankCard.vue?vue&type=style&index=0&id=1dfc39c4&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dfc39c4"]])

export default __exports__